import Img1 from 'assets/innvolight/innovative-features/img1.png'
import Img2 from 'assets/innvolight/innovative-features/img2.png'
import Img3 from 'assets/innvolight/innovative-features/img3.png'
import Img4 from 'assets/innvolight/innovative-features/img4.png'
import Img5 from 'assets/innvolight/innovative-features/img5.png'
import Img6 from 'assets/innvolight/innovative-features/img6.png'
import Img7 from 'assets/innvolight/innovative-features/img7.png'
import Img8 from 'assets/innvolight/innovative-features/img8.png'
import Img9 from 'assets/innvolight/innovative-features/img9.png'

export default function InnovativeFeatures() {
  return (
    <div className="relative h-auto bg-center bg-slate-100">
      <div className="relative z-10 max-w-[1440px] w-full mx-auto h-full py-20  px-4  md:px-10 lg:px-16 2xl:px-0">
        <div className="flex flex-col gap-10">
          <div className="flex justify-start w-full">
            <h3 className="text-2xl font-bold text-left text-black sm:text-2xl md:text-3xl gsap-opacity-trans-appear">
              <span className="text-orange">Innovative</span> Features
            </h3>
          </div>
          <div className="grid w-full gap-10 mx-auto sm:grid-cols-2 max-w-7xl gsap-stagger-bounce-parent">
            <div className="flex flex-col w-full gap-5 gsap-stagger-bounce">
              <div className="w-full max-w-[60px] sm:max-w-[80px]">
                <img
                  className="object-contain w-full h-full"
                  src={Img1}
                  alt=""
                />
              </div>{' '}
              <h4 className="text-xl font-bold md:text-2xl text-orange">
                Combining Imaging{' '}
                {/* <span className="text-transparent bg-gradient-to-b from-[#f0723d] to-[#ea463a] bg-clip-text"> */}
                with Physiology:
                {/* </span> */}
              </h4>
              <p className="text-base text-black sm:text-lg md:text-xl">
                Advanced VFR{' '}
                <span className="font-bold">(Virtual Flow Ratio).</span>
              </p>
            </div>
            <div className="flex flex-col w-full gap-5 gsap-stagger-bounce">
              <div className="w-full max-w-[60px] sm:max-w-[80px]">
                <img
                  className="object-contain w-full h-full"
                  src={Img2}
                  alt=""
                />
              </div>{' '}
              <h4 className="text-xl font-bold md:text-2xl text-orange">
                Advanced ACR{' '}
                {/* <span className="text-transparent bg-gradient-to-b from-[#f0723d] to-[#ea463a] bg-clip-text"> */}
                Capability:
                {/* </span> */}
              </h4>
              <p className="text-base text-black sm:text-lg md:text-xl">
                Integrated{' '}
                <span className="font-bold">Angiographic Co-Registration.</span>
              </p>
            </div>
            <div className="flex flex-col w-full gap-5 gsap-stagger-bounce">
              <div className="w-full max-w-[60px] sm:max-w-[80px]">
                <img
                  className="object-contain w-full h-full"
                  src={Img3}
                  alt=""
                />
              </div>{' '}
              <h4 className="text-xl font-bold md:text-2xl text-orange">
                Super Fast Mode:
              </h4>
              <ul className="flex flex-col gap-3 pl-5 text-base list-disc sm:text-lg md:text-xl">
                <li>
                  <span className="font-bold">80 mm</span> in just{' '}
                  <span className="font-bold">2 sec</span>
                </li>
                <li>
                  <span className="font-bold">55 mm</span> HD scan in{' '}
                  <span className="font-bold">2.75 sec</span>
                </li>
                <li>
                  <span className="font-bold">40 mm</span> rapid scan in{' '}
                  <span className="font-bold">1 sec</span>
                </li>
              </ul>
            </div>
            <div className="flex flex-col w-full gap-5 gsap-stagger-bounce">
              <div className="w-full max-w-[60px] sm:max-w-[80px]">
                <img
                  className="object-contain w-full h-full"
                  src={Img4}
                  alt=""
                />
              </div>{' '}
              <h4 className="text-xl font-bold md:text-2xl text-orange">
                Excellent Lesion{' '}
                {/* <span className="text-transparent bg-gradient-to-b from-[#f0723d] to-[#ea463a] bg-clip-text"> */}
                Crossing Ability:
                {/* </span> */}
              </h4>
              <p className="text-base text-black sm:text-lg md:text-xl">
                Low profile <span className="font-bold">2.58 Fr (0.86mm)</span>
              </p>
            </div>
            <div className="flex flex-col w-full gap-5 gsap-stagger-bounce sm:col-span-2 md:col-span-1">
              <div className="w-full max-w-[60px] sm:max-w-[80px]">
                <img
                  className="object-contain w-full h-full"
                  src={Img5}
                  alt=""
                />
              </div>{' '}
              <h4 className="text-xl font-bold md:text-2xl text-orange">
                Muitimodality Intelligence:
              </h4>
              <p className="text-base text-black sm:text-lg md:text-xl">
                Smarter decision-making with{' '}
                <span className="font-bold">IPA</span> (Index of Plaque
                Attenuation) and <span className="font-bold">ICA</span>{' '}
                (Intelligent Calcium Assessment)
              </p>
            </div>
          </div>
          <div className="flex flex-col w-full max-w-5xl gap-10 mx-auto">
            <div className="flex flex-col items-center justify-center gap-2 gsap-opacity-trans-appear">
              <div className="w-full max-w-2xl">
                <img
                  src={Img6}
                  className="object-contain w-full h-full"
                  alt=""
                />
              </div>
              <h4 className="text-sm font-bold text-center sm:text-lg md:text-base lg:text-2xl">
                <span className="text-orange">ACR</span> (Angiographic
                Co-registration with OCT)
              </h4>
            </div>
            <div className="grid gap-10 sm:grid-cols-2 gsap-opacity-trans-appear">
              <div>
                <div className="flex flex-col items-center justify-center gap-2 text-center">
                  <img
                    src={Img7}
                    className="w-auto h-[280px] md:h-[320px] lg:h-[420px]"
                    alt=""
                  />
                  <h4 className="text-sm font-bold text-center sm:text-lg md:text-base lg:text-2xl">
                    <span className="text-orange">Intelligent</span>
                    <br /> Evaluation of BRS
                  </h4>
                </div>
              </div>
              <div>
                <div className="flex flex-col items-center justify-center gap-2 text-center">
                  <img
                    src={Img8}
                    className="w-auto h-[280px] md:h-[320px] lg:h-[420px]"
                    alt=""
                  />
                  <h4 className="text-sm font-bold text-center sm:text-lg md:text-base lg:text-2xl">
                    <span className="text-orange">Auto Quantitative</span>
                    <br /> Bifurcation Assessment
                  </h4>
                </div>
              </div>
            </div>
            <div className="flex flex-col items-center justify-center gap-2 gsap-opacity-trans-appear">
              <div className="w-full max-w-4xl">
                <img
                  src={Img9}
                  className="object-contain w-full h-full"
                  alt=""
                />
              </div>
              <h4 className="text-sm font-bold text-center sm:text-lg md:text-base lg:text-2xl">
                Auto-Calculation of Neointimal Coverage
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
